import { Commit } from 'vuex';
import { DoeState } from '@/modules/DOE/store/state';

export enum DoeActions{
    GET_DOE_PUBLIE = 'GET_DOE_PUBLIE',
    GET_PDF_DOE = 'GET_PDF_DOE'
}

export interface DoeActionTypes {
    commit: Commit;
    state: DoeState;
    getters: any;
}
